import React from 'react';
import { Document, Page, Text, View } from '@react-pdf/renderer';
import {
  styles,
  DIAS_SEMANA,
  SimpleTable,
  SummaryBox,
  MedicaoCapa,
  MedicaoCabecalho,
  MedicaoRodape,
  formatDateBrPdf,
  formatInteiroPdf,
} from './pdf/MedicaoPdfBase';

const TITULO = 'MEDIÇÃO - MOLDAGEM';

const colunasDia = [
  { key: 'data', label: 'Data de concretagem', width: '30%', render: (r) => formatDateBrPdf(r.data) },
  { key: 'diaSemana', label: 'Dia da semana', width: '25%', render: (r) => DIAS_SEMANA[r.diaSemana] ?? '-' },
  { key: 'qtdCaminhao', label: 'Caminhões moldados', width: '22%' },
  { key: 'qtdCp', label: "CP's moldados", width: '23%' },
];

const colunasCp = [
  { key: 'dataConcretagem', label: 'Data de moldagem', width: '14%', render: (r) => formatDateBrPdf(r.dataConcretagem) },
  { key: 'etiqueta', label: 'Identificador (ID - Etiqueta)', width: '20%' },
  { key: 'notaFiscal', label: 'Nota fiscal', width: '16%' },
  { key: 'tipoCorpoProva', label: 'Tipo de CP', width: '16%' },
  { key: 'idadeRuptura', label: 'Idade (dias)', width: '10%', render: (r) => formatInteiroPdf(r.idadeRuptura) },
  { key: 'fck', label: 'Fck (MPa)', width: '10%', render: (r) => formatInteiroPdf(r.fck) },
  { key: 'dataRuptura', label: 'Ruptura prevista', width: '14%', render: (r) => formatDateBrPdf(r.dataRuptura) },
];

// Documento PDF da Medição de Moldagem: capa, resumo dia a dia e relação sequencial de CPs moldados no período.
function MedicaoMoldagemPDF({
  resumo,
  cps = [],
  empresaNome = '',
  obraNome = '',
  periodo = '',
  logoCliente = null,
  assinaturas = [],
}) {
  const porDia = resumo?.porDia ?? [];
  const linhasCp = cps.map((cp) => ({
    ...cp,
    key: cp.idCorpoProva,
    notaFiscal: cp.numrNotaFiscalPrincipal ?? cp.numrNotaFiscalSecundaria ?? '-',
    etiqueta: cp.etiqueta || '-',
    tipoCorpoProva: cp.tipoCorpoProva || '-',
  }));
  const cabecalho = (
    <MedicaoCabecalho titulo={TITULO} logoCliente={logoCliente} empresa={empresaNome} obra={obraNome} periodo={periodo} />
  );

  return (
    <Document>
      <MedicaoCapa kicker="MEDIÇÃO" titulo="Medição de Moldagem de Corpos de Prova" empresa={empresaNome} obra={obraNome} periodo={periodo} />

      <Page size="A4" orientation="landscape" style={styles.page}>
        {cabecalho}
        <View style={styles.summaryRow}>
          <SummaryBox value={resumo?.totalCaminhoes ?? 0} label="Caminhões moldados" />
          <SummaryBox value={resumo?.totalCps ?? 0} label="CPs moldados" />
          <SummaryBox value={resumo?.cpsSabado ?? 0} label="CPs moldados aos sábados" />
          <SummaryBox value={resumo?.cpsDomingo ?? 0} label="CPs moldados aos domingos" />
        </View>

        <Text style={styles.sectionTitle}>Histórico dia a dia</Text>
        {porDia.length === 0 ? (
          <Text>Nenhuma moldagem no período.</Text>
        ) : (
          <SimpleTable
            columns={colunasDia}
            rows={porDia.map((d) => ({ ...d, key: d.data }))}
            rowStyle={(r) => (r.diaSemana === 0 || r.diaSemana === 6 ? styles.weekend : null)}
          />
        )}
        <MedicaoRodape assinaturas={assinaturas} />
      </Page>

      <Page size="A4" orientation="landscape" style={styles.page}>
        {cabecalho}
        <Text style={styles.sectionTitle}>Corpos de prova moldados no período (ordem de data)</Text>
        {linhasCp.length === 0 ? <Text>Nenhum corpo de prova no período.</Text> : <SimpleTable columns={colunasCp} rows={linhasCp} />}
        <MedicaoRodape assinaturas={assinaturas} />
      </Page>
    </Document>
  );
}

export default MedicaoMoldagemPDF;
